import { addDays } from 'date-fns';

export const getUpcomingSessionShortcuts = () => {
  const today = new Date();

  return [
    {
      label: 'Today',
      getValue: () => [today, today] as [Date, Date],
    },
    {
      label: 'Next 7 days',
      getValue: () => [today, addDays(today, 7)] as [Date, Date],
    },
    {
      label: 'Next 14 days',
      getValue: () => [today, addDays(today, 14)] as [Date, Date],
    },
    {
      label: 'Next 30 days',
      getValue: () => [today, addDays(today, 30)] as [Date, Date],
    },
  ];
};
